import { Button } from "components/Button";
import {
  COOKIE_ACCEPT,
  COOKIE_BAR_MESSAGE,
  COOKIE_UPDATE,
  translate,
} from "shared/translate";
import { MaxWidth } from "components/MaxWidth";
import { TYPE_LINK } from "shared/constants";
import { useRouter } from "next/router";
import styles from "./CookieBar.module.css";

export const CookieBar = ({ setAccepted, setAdvertising }) => {
  const router = useRouter();

  const onOkay = () => {
    setAdvertising(1);
    setAccepted(1);
  };

  const onChangeClick = () => {
    router.push(`/${router?.locale}/cookies?redirect=1`);
    setAccepted(1);
  };

  return (
    <div className={styles.container}>
      <MaxWidth>
        <p className={styles.text}>
          {translate(COOKIE_BAR_MESSAGE, router.locale)}
        </p>
        <div className={styles.buttonContainer}>
          <Button onClick={onOkay}>
            {translate(COOKIE_ACCEPT, router.locale)}
          </Button>
          <Button onClick={onChangeClick} isInverted type={TYPE_LINK}>
            {translate(COOKIE_UPDATE, router.locale)}
          </Button>
        </div>
      </MaxWidth>
    </div>
  );
};
